<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'roomList'}"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника типов помещений:</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="room">


								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('room')">
										<label>{{mapElementName['roomName']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['roomName']"></md-input>
										<md-input type="text" v-else v-model="form['roomName']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.roomName.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('roomCode')">
										<label>{{mapElementName['roomCode']}}</label>
										<md-input readonly type="text" v-if="action === 'delete'"
												  v-model.number="form['roomCode']"></md-input>
										<md-input type="text" v-else v-model="form['roomCode']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.roomCode.required">Обязательно для заполнения</span>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="room">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>

                        <template v-if="citiesParams">
                            <div 
                                class="md-layout-item md-size-100 md-small-size-100 mx-auto citiparams"
                                v-for="(param, index1) in citiesParams"
                                :key="index1"
                            >
                                <h4 class="title">{{ citiesList.find(city => city.id === param.locationId).city }}</h4>
                                <div 
                                    class="md-layout"
                                    v-for="(paramType, index2) in param.windowParamType"
                                    :key="index2"
                                >
                                    <div class="md-layout-item md-size-33 md-small-size-100">
                                        <md-field>
                                            <label>{{ paramType.typeName }} min</label>
                                            <md-select 
                                                    :id="'min_' + param.locationId + '_' + paramType.id"
                                                    :name="'min_' + param.locationId + '_' + paramType.id"
                                                    :value="paramType.minValue"
                                                    @md-selected="setMinParamVal(param.locationId, paramType.id, $event)"
                                                    md-dense
                                                    name="paramType"
                                            >
                                                <md-option 
                                                    :value="item.id"
                                                    v-for="item in _.orderBy(paramType.values, 'typeValVal', 'asc')"
                                                    v-bind:key="'min_' + param.locationId + '_' + item.id"
                                                >{{ item.typeValVal}}: {{item.typeValDesc }}
                                                </md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-33 md-small-size-100">
                                        <md-field>
                                            <label>{{ paramType.typeName }} max</label>
                                            <md-select :value="paramType.maxValue"
                                                    @md-selected="setMaxParamVal(param.locationId, paramType.id, $event)"
                                                    md-dense
                                                    name="paramType"
                                            >
                                                <md-option 
                                                    :value="item.id"
                                                    v-for="item in _.orderBy(paramType.values, 'typeValVal', 'asc')"
                                                    v-bind:key="'max_' + param.locationId + '_' +item.id"
                                                >{{ item.typeValVal}}: {{item.typeValDesc }}
                                                </md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-33 md-small-size-100">
                                        <md-field>
                                            <label>{{ paramType.typeName }} По умолчанию</label>
                                            <md-select :value="paramType.defaultValue"
                                                    @md-selected="setDefaultParamVal(param.locationId, paramType.id, $event)"
                                                    md-dense
                                                    name="paramType"
                                            >
                                                <md-option 
                                                    :value="item.id"
                                                    v-for="item in _.orderBy(paramType.values, 'typeValVal', 'asc')"
                                                    v-bind:key="'def_' + param.locationId + '_' +item.id"
                                                >{{ item.typeValVal}}: {{item.typeValDesc }}
                                                </md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                </div>
                                <md-button @click="saveItemParams(param.locationId)"
                                        class="md-button md-success md-theme-default">
                                    Сохранить
                                </md-button>
                            </div>
                        </template>
					</div>
				</div>

			</div>
		</div>
		<md-dialog-alert
				:md-active.sync="saveSuccess"
				md-content="Данные успешно сохранены"
		/>
        <success-alert ref="successAlert" />
        <error-alert ref="errorAlert" />
        <warning-alert ref="warningAlert" />
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { getItem } from '@/utils/dict-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { getRooms, updateRoom, removeRoom } from '@/utils/room-api'
    import { getAccessToken } from '../../utils/auth-fn'
	import {appConfig} from '../../utils/config-api'
	import _ from 'lodash'
    import SuccessAlert from '@/components/SuccessAlert.vue'
    import ErrorAlert from '@/components/ErrorAlert.vue'
    import WarningAlert from '@/components/WarningAlert.vue'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        components: {
            SuccessAlert,
            ErrorAlert,
            WarningAlert
        },
        data () {
            return {
                room: false,
                mapElementName: {
                    'roomName': 'Название',
                    'roomCode': 'Код',
                },
                form: {
                    action: 'save',
                    roomName: '',
                    roomCode: '',
                },
                citiesList: false,
                citiesParams: [],
                saveSuccess: false,
            }
        },
        validations: {
            form: {
                roomName: {
                    required,
                },
                roomCode: {
                    required,
                },
            },
        },
		computed: {
            _ () {
                return _
            },
		},
        watch: {},
        methods: {
            setMinParamVal (cityId, paramId, val) {
                let cityItemIndex = this.citiesParams.findIndex(city => city.locationId === cityId)
                let paramItemIndex = this.citiesParams[cityItemIndex].windowParamType.findIndex(param => param.id === paramId)
                this.citiesParams[cityItemIndex].windowParamType[paramItemIndex].minValue = val
            },
            setMaxParamVal (cityId, paramId, val) {
                let cityItemIndex = this.citiesParams.findIndex(city => city.locationId === cityId)
                let paramItemIndex = this.citiesParams[cityItemIndex].windowParamType.findIndex(param => param.id === paramId)
                this.citiesParams[cityItemIndex].windowParamType[paramItemIndex].maxValue = val
            },
            setDefaultParamVal (cityId, paramId, val) {
                let cityItemIndex = this.citiesParams.findIndex(city => city.locationId === cityId)
                let paramItemIndex = this.citiesParams[cityItemIndex].windowParamType.findIndex(param => param.id === paramId)
                this.citiesParams[cityItemIndex].windowParamType[paramItemIndex].defaultValue = val
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.form = data
            },
            getElementData: async function () {
                if (this.$route.params.id === 'new') {
                    this.addItem()
                    return
                }

                this.room = await getRooms()
                this.room = this.room.find(item => +item.id === +this.$route.params.id)
                this.setData(this.room)

                this.citiesList = await getItem('location')
                let paramsTpl = await this.fetchAllParams()
                paramsTpl = paramsTpl.filter(param => param.paramType === 'V')

                for (const city of this.citiesList) {
                    let params = await this.fetchParams(city.id)
                    if (!params.windowParamType || params.windowParamType.length === 0) {
                        params.windowParamType = _.cloneDeep(paramsTpl)
                    } else {
                        for (var pt of paramsTpl) {
                            var pr = params.windowParamType.find(item => +item.id === +pt.id)
                            if (!pr) {
                                params.windowParamType.push(_.cloneDeep(pt))
                            }
                        }
                    }
                    this.citiesParams.push(params)
                }
            },
            fetchParams (cityId) {
                return fetch(`${appConfig.backendUrl}/rest/room/getparams?locationId=${cityId}&roomTypeId=${this.$route.params.id}`)
                  .then(response => {
                      return response.json()
                  })
                  .catch(error => {
                      console.log(error)
                  })
            },
            fetchAllParams () {
                return fetch(`${appConfig.backendUrl}/rest/windowparamtype/getall`)
                  .then(response => {
                      return response.json()
                  })
                  .catch(error => {
                      console.log(error)
                  })
            },
            addItem: function () {
                const item = {
                    'id': 'new',
                    'roomName': '',
                    'roomCode': '',
                }
                this.setData(item)
                this.room = item

            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    updateRoom(JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'roomList' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            saveItemParams: function (cityId) {
                const data = this.citiesParams.find(item => item.locationId === cityId)
                checkAuthentication(this.$router, this.$route).then(response => {
                    fetch(`${appConfig.backendUrl}/worker/room/param/save/`, {
                        method: 'POST',
                        headers: {
                            'authorization': `Bearer ${getAccessToken()}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    }).then(response => {
                        if (+response.status === 200) {
                            this.saveSuccess = true
                        } else if (+response.status === 401) {
                            reAuthenticate(this.$router, this.$route, response)
                        } else {
                            this.$refs.errorAlert.errorShow('Неизвестная ошибка. Попробуйте позже.')
                        }
                    }).catch( (error) => {
                        console.log('save error:')
                        console.log(error)
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    removeRoom(JSON.stringify({ id: this.$route.params.id })).then(result => {
                        this.$router.push({ name: 'roomList' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}

	.citiparams {
		margin-top: 50px;
	}
</style>
